export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGIN_ADTHRIVE_USER_SUCCESS = 'LOGIN_ADTHRIVE_USER_SUCCESS';
export const SET_ADTHRIVE_SITES = 'SET_ADTHRIVE_SITES';
export const SET_ACTIVE_SITE = 'SET_ACTIVE_SITE';

export const BRIEFS_SUCCESS = 'BRIEFS_SUCCESS';
export const SET_BRIEFS_LOADING = 'SET_BRIEFS_LOADING';

export const SET_ACTIVE_BRIEF = 'SET_ACTIVE_BRIEF';

export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_CURRENT_POST_ID = 'SET_CURRENT_POST_ID';
export const SET_CURRENT_PAGE_LOADING = 'SET_CURRENT_PAGE_LOADING';
export const SET_SHOULD_TRY_AUTOLOADING = 'SET_SHOULD_TRY_AUTOLOADING';